import {
    getSearch, ListHeaderItem, RequestData, SearchKey
} from '@/components/common/list';
import { ref, Ref } from 'vue';
import router, { propertyBaseRouter, propertyOldCommunitySubRouter } from '@/router';

const searchKeyList: SearchKey = [
    {
        name: 'Name',
        label: WordList.TabelPersonUserInHtmlName
    }, {
        name: 'Key',
        label: WordList.DeliveryRfCard
    }
];

const headers: Array<ListHeaderItem> = [
    {
        label: WordList.TabelPersonUserInHtmlName,
        name: 'Name'
    }, {
        label: WordList.DeliveryRfCard,
        name: 'Code'
    }, {
        label: WordList.ProperAllTextRepeats,
        name: 'Repeats'
    }, {
        label: WordList.TabelUpdateBoxDevice,
        name: 'DevicesText'
    }, {
        label: WordList.TabelMessageBoxCreateTime,
        name: 'CreateTime'
    }
];

const initRfCard = () => {
    // list请求借口及请求参数
    const requestData: Ref<RequestData> = ref({
        url: 'v3/web/community/delivery/getDeliverRfCardListForOld',
        param: getSearch({
            searchKey: 'Name',
            searchValue: ''
        })
    });

    // list搜索查询处理
    const updateList = ref(0);
    const saveParamInPath = ref(false);
    const searchList = () => {
        updateList.value += 1;
        saveParamInPath.value = true;
    };

    const add = () => {
        router.push(`/${propertyBaseRouter}/${propertyOldCommunitySubRouter.oldAddDeliveryAuth}?type=rfCard&opera=add`);
    };

    const edit = (val: object) => {
        localStorage.setItem('modifyKey', '1');
        localStorage.setItem('propertyKeyDetail', JSON.stringify(val));
        router.push(`/${propertyBaseRouter}/${propertyOldCommunitySubRouter.oldAddDeliveryAuth}?type=rfCard&opera=edit`);
    };

    return {
        requestData,
        updateList,
        saveParamInPath,
        searchList,
        searchKeyList,
        add,
        edit,
        headers
    };
};

export default initRfCard;
